module.exports = __webpack_public_path__ + "media/images/flags/16/Bermuda-7acc3e87fcdd099afeb3240661256838.png";